// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productLinesStyles } from "@rpsc/Overrides/Widgets/BrandDetails/BrandDetailsProductLines";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productLinesStyles.title = {
    variant: "h4",
    css: css`
        margin-bottom: 32px;
    `,
};

productLinesStyles.productLineImageItem = {
    css: css`
        justify-content: center;
    `,
};

productLinesStyles.titleItem = {
    width: 12,
    css: css`
        width: 100%;
        justify-content: start;
    `,
};

productLinesStyles.container = {
    css: css`
        margin: 30px 15px;
    `,
};

productLinesStyles.productLineContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        ${({ gridType }: any) => {
            if (gridType !== "row") {
                return css`
                    flex-direction: column;
                    ${xScreen("lte", "xs")} {
                        align-items: center;
                    }
                `;
            } else {
                return css`
                    ${xScreen("lte", "xs")}{
                        justify-content: center;
                    }
                `
            }
        }}
    `,
};

productLinesStyles.innerProductLineContainer = {
    css: css`
        max-width: 198px;
        & > a > ${TypographyStyle} {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        ${xScreen("lte", "md")} {
            max-width: 166px;
        }
        ${xScreen("lte", "sm")} {
            max-width: 100%;
        }
         ${TypographyStyle}:hover {
            color: ${color("common.ui8")};
        }
        
    `,
};

productLinesStyles.productLineImage = {
    css: css`
        object-fit: cover;
        width: 143px;
        height: 143px;
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        img {
            width: 100%;
        }
        ${xScreen("lte", "xs")} {
            width: 120px;
            height: 120px;
        }
    `,
};

productLinesStyles.productLineName = {
    size: 15,
    weight: fontConfig.weight.bold,
    color: "text.main",
    css: css`
        ${ellipsis(2)};
        width: 100%;
        text-align: center;
    `,
};
